import React from 'react';
import { Modal } from 'react-bootstrap';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';

const ImportIngredientError = (props) => {
  const { showImportError, setShowImportError, errorMessage } = props;

  return (
    <Modal
      id="importingredienterror-modal-wrapper"
      className="z-[1501]"
      backdropClassName="z-[1500]"
      dialogClassName="importIngredientError-Modal"
      show={showImportError}
      onHide={() => setShowImportError(false)}
    >
      <Modal.Body id='importingredienterror-modal-body'>
        <div id="importingredienterror-container" className="w-[100%] h-[100%] flex flex-col">
          <div id="importingredienterror-header" className="w-[100%] h-[77.5%] flex flex-col">
            <div id="importingredienterror-title" className="w-[90.62%] h-[32.55%] text-[#1B1B1B] text-[1.538rem] content-center self-center">
              Import Protein
            </div>
            <div  id="importingredienterror-errorbox" className="w-[90.62%] h-[37.2%] bg-[#FFF0F0] border-l-[3px] border-r border-b border-t border-[#FF5252] border-solid self-center justify-items-center content-center">
              <div id="importingredienterror-errorcontent"className="w-[95.46%] h-[64.5%] flex flex-row">
                <div id="importingredienterror-icon-wrapper" className="h-[100%] w-[8%] text-center">
                  <RMSvgIcon
                    id="importingredienterror-icon"
                    name="Error"
                    width={'1.231rem'}
                    height={'1.231rem'}
                    fill="#FF5252"
                  />
                </div>
                <div id="importingredienterror-message" className="h-[100%] text-[#1B1B1B] text-[1.077rem] w-[92%]">
                  Failed to import protein.
                </div>
              </div>
            </div>
            <div id="importingredienterror-description" className="w-[90.62%] self-center mt-[2%] text-[#5D5D5D] text-[1.077rem]">
              {errorMessage ?? (
                <>
                  Select the file in a valid format and try again. For more information,
                  visit our{' '}
                  <a
                    id="importingredienterror-help-link"
                    target="_blank"
                    href="https://help.formulatrix.com/rock-maker/4.10/Content/Experiment_Design/Experiment_Design_Tutorials/Designing_Experiments/Creating_a_Protein_Variant.html"
                    rel="noreferrer"
                  >
                    online help
                  </a>
                  .
                </>
              )}
            </div>
          </div>
          <div id="importingredienterror-footer" className="w-[100%] h-[22.5%] border-t border-b-0 border-l-0 border-r-0 border-[#CACACA] border-solid content-center justify-items-end">
            <RMCustomButton
              onClick={() => {
                setShowImportError(false);
              }}
              isDisabled={false}
              title={'OK'}
              titleClass="text-[#FFFFFF] text-[1.077rem]"
              titleTip={'Import Ingredients'}
              contentContainerClass={'w-[100%] h-[100%] bg-[#F7A246] '}
              mainContainerClass={'w-[5.923rem] h-[2.615rem] mr-[2%]'}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ImportIngredientError;
